import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: CustomHttpService) { }

  uploadDocuments(data:FormData): Observable<any> {
    return this.http.post(environment.upload,data);
  }


  
  
  
  
  
}
